import { useState } from "react";

export default function ContatoForm() {
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("enviando");

    const form = e.target;
    const data = new FormData(form);

    try {
      const response = await fetch("https://formsubmit.co/contato@dygito.com.br", {
        method: "POST",
        body: data,
      });

      if (response.ok) {
        setStatus("sucesso");
        form.reset();
      } else {
        setStatus("erro");
      }
    } catch (error) {
      setStatus("erro");
    }
  };

  return (
    <section id="contact" className="py-20 bg-white text-center">
      <h3 className="text-3xl font-semibold text-gray-800 mb-6">Entre em Contato</h3>
      <p className="text-gray-600 mb-10">
          Pronto para transformar seus dados em valor? Fale conosco e descubra como podemos ajudar seu negócio.
        </p>

      <form onSubmit={handleSubmit} className="max-w-xl mx-auto grid grid-cols-1 gap-4 text-left">
        <input type="hidden" name="_subject" value="Nova mensagem via site Dygito" />
        <input type="hidden" name="_captcha" value="false" />
        <input type="hidden" name="_template" value="table" />

        <input
          type="text"
          name="nome"
          placeholder="Nome"
          required
          className="border border-gray-300 p-3 rounded"
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          required
          className="border border-gray-300 p-3 rounded"
        />
        <input
          type="tel"
          name="celular"
          placeholder="Celular"
          className="border border-gray-300 p-3 rounded"
        />
        <input
          type="text"
          name="empresa"
          placeholder="Empresa"
          className="border border-gray-300 p-3 rounded"
        />
        <select
          name="cargo"
          required
          className="border border-gray-300 p-3 rounded"
        >
          <option value="">Selecione seu cargo</option>
          <option value="Sócio / CEO">Sócio / CEO</option>
          <option value="Diretor">Diretor</option>
          <option value="Gerente">Gerente</option>
          <option value="Coordenador / Supervisor">Coordenador / Supervisor</option>
          <option value="Analista / Produtor">Analista / Produtor</option>
          <option value="Estagiário">Estagiário</option>
          <option value="Estudante">Estudante</option>
          <option value="Outro">Outro</option>
        </select>
        <textarea
          name="mensagem"
          placeholder="Mensagem"
          required
          className="border border-gray-300 p-3 rounded h-32"
        ></textarea>

        <button
          type="submit"
          className="bg-blue-600 hover:bg-blue-700 transition-colors text-white py-3 px-6 rounded-full"
        >
          {status === "enviando" ? "Enviando..." : "Enviar"}
        </button>

        {status === "sucesso" && <p className="text-green-600 mt-2">Mensagem enviada com sucesso!</p>}
        {status === "erro" && <p className="text-red-600 mt-2">Erro ao enviar. Tente novamente.</p>}
      </form>
    </section>
  );
}
